import Button from 'components/base/Button';
import useGotoProfile from 'hooks/useGotoProfile';
import classlist from 'utils/classlist';
import config, { StatusType } from './config';
import './style.scss';

/**
 * @description 表示当前步骤已完成的页面
 */
export interface ResultPageProps {
    status?: StatusType; // 当前状态
    onClick?: (ev: React.MouseEvent) => void; // 默认返回个人中心
    header?: string; // 页面的顶部文案
    className?: string;
    contentOptions?: {
        text?: React.ReactNode; // 提示文案
        className?: string; // 提示文案的类名
    };
    descriptionOptions?: {
        text?: React.ReactNode; // 页面二级文案
        className?: string; // 页面二级文案的类名
    };
    iconOptions?: {
        className?: string; // 页面图标的类名
        icon?: string | React.ReactElement; // 页面图标
        style?: React.CSSProperties; // icon的样式
        containerClassName?: string;
    };
    btnOptions?: {
        text?: string; // 按钮文案
        show?: boolean; // 显示底部按钮, 默认显示
        quitInApp?: boolean; // 点击按钮是否退出app, 默认退出
    };
}

const ResultPage: React.FC<ResultPageProps> = props => {
    const {
        status,
        header,
        onClick,
        contentOptions: { text: content, className: contentClassName } = {},
        descriptionOptions: { text: description, className: descriptionClassName } = {},
        btnOptions: { text: btnText, show: showBtn = true, quitInApp } = {},
        iconOptions: {
            icon,
            className: iconClassName,
            style: iconStyle,
            containerClassName: iconContainerClassName
        } = {},
        className
    } = props;
    const goToProfile = useGotoProfile(!!quitInApp);
    const statusConfig = status ? config[status] : undefined;
    // 如果传递有值，就按传递的处理；否则按照默认的文案进行展示
    const finalContent = content || statusConfig?.content;
    const finalBtnText = btnText || statusConfig?.btnText || config.PENDING.btnText;
    const imgSrc = icon || statusConfig?.img || config.PENDING.img;

    const handleClick = () => {
        goToProfile();
    };

    return (
        <div className={classlist('result-page-root', className)}>
            {header && <h2 className="header my-3">{header}</h2>}
            <div className={classlist('icon-container', iconContainerClassName)}>
                {typeof imgSrc === 'string' ? (
                    <img
                        src={imgSrc}
                        alt={typeof finalContent === 'string' ? finalContent : ''}
                        className={classlist('image', iconClassName)}
                        style={iconStyle}
                    />
                ) : (
                    imgSrc
                )}
            </div>
            {finalContent && <div className={classlist('content', contentClassName)}>{finalContent}</div>}
            {description && <div className={classlist('description', descriptionClassName)}>{description}</div>}
            {showBtn && (
                <Button block size="lg" className="btn" onClick={onClick ?? handleClick}>
                    {finalBtnText}
                </Button>
            )}
        </div>
    );
};

export default ResultPage;
